import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();

var Flickity = require('flickity');
global.Flickity = Flickity;
require('flickity-imagesloaded');
require('flickity-as-nav-for');
require('flickity-fade');
import 'flickity/css/flickity.css';

import SectionContainer from '../sections/section-container';

import Collapsible from '../components/collapsible';
import Modal from '../components/modal';
import Responsive from '../tools/responsive';

import LoadingBar from '../tools/loading-bar';
import Popover from '../components/popover';
import CartSection from '../components/cart-section';
import SlideshowSection from '../sections/slideshow';
import HeaderSection from '../sections/header';
import SidebarMenuSection from '../components/sidebar-menu';
import NewsletterPopupSection from '../sections/newsletter-popup-section';

import FeaturedProductSection from '../sections/featured-product-section';

import '../components/smooth-scroll';
import '../components/modal';
import '../components/collapsible';
import '../components/carousel';
import '../components/popup';
import '../components/animations';
import '../components/iframe';
import '../components/mediabox';

import $ from 'jquery';

global.$ = global.jQuery = $;

global._defineProperty = (obj, key, value) => {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
};

import '../components/cart';

// import '../tools/breakpoints'

import '../../styles/theme.scss';
import '../../styles/static/tailwind.scss';
import CollageSection from '../sections/collage';
import TextColumnsSection from '../sections/text-columns-with-image';

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className =
    document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
}

// First, we register all plugins thate are used for all pages
new Collapsible();
new Modal();
new Responsive();
// if (window.theme.template !== 'password' && window.theme.template !== 'gift_card') {
//   new LoadingBar();
// }

document.querySelectorAll('.popover').forEach(function (popover) {
  if (popover.classList.contains('optionSelector')) {
    return false;
  }
  new Popover(popover, {
    showOverlay: true,
  });
});

// register all plugins that are used for all pages
if (
  window.theme.template !== 'password' &&
  window.theme.template !== 'gift_card'
) {
  new LoadingBar();
}

// Adding tabs for site wide
// tabbed content
$('.tab_content').hide();
$('.tab_content:first').show();

/* if in tab mode */
$('ul.tabs li').click(function () {
  $('.tab_content').hide();
  var activeTab = $(this).attr('rel');
  $('#' + activeTab).fadeIn();

  $('ul.tabs li').removeClass('active');
  $(this).addClass('active');

  $('.tab_drawer_heading').removeClass('d_active');
  $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass('d_active');
});

/* if in drawer mode */
$('.tab_drawer_heading').click(function () {
  $('.tab_content').hide();
  var d_activeTab = $(this).attr('rel');
  $('#' + d_activeTab).fadeIn();

  $('.tab_drawer_heading').removeClass('d_active');
  $(this).addClass('d_active');

  $('ul.tabs li').removeClass('active');
  $("ul.tabs li[rel^='" + d_activeTab + "']").addClass('active');
});

/* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
$('ul.tabs li').last().addClass('tab_last');

//Checkout enable/disable
$('body').on('click', '.cart__checkout', function (e) {
  let chkagree = $('#checkagree');
  let errcart = $('.cart-checkout-agree-error');
  if ($(chkagree).is(':checked')) {
    return;
  } else {
    e.preventDefault();
    errcart.show('fast');
    $('.cart__checkout').attr('disabled', 'disabled');
    setTimeout(() => {
      $('.cart__checkout').removeAttr('disabled');
      errcart.hide('fast');
    }, 2500);
  }
});

// instantiate specific sections that may appear in all pages
global.sections = new SectionContainer();

sections.register('header', HeaderSection);
sections.register('slideshow', SlideshowSection);
sections.register('sidebar-menu', SidebarMenuSection);
sections.register('cart', CartSection);
sections.register('newsletter-popup', NewsletterPopupSection);
sections.register('featured-product', FeaturedProductSection);
sections.register('collage', CollageSection);
sections.register('text-columns-with-image', TextColumnsSection);
